(function () {
  function calculateROI({ buyPrice, marketValue, fees = 0 }) {
    const cost = Number(buyPrice) || 0;
    const value = Number(marketValue) || 0;
    const totalFees = Number(fees) || 0;

    const profit = value - cost - totalFees;

    const roi =
      cost > 0
        ? ((profit / cost) * 100).toFixed(1)
        : "0.0";

    return {
      profit: Number(profit.toFixed(2)),
      roi: Number(roi)
    };
  }

  window.GCAROIEngine = {
    calculateROI
  };

  console.log("📈 GCA ROI Engine loaded");
})();
